import CookieRecord from '@/models/cookies/cookie-record'
import { ICookieState } from './interfaces/cookie-state'
export default class CookieState implements ICookieState {
  public selectedCookieRecord: CookieRecord = new CookieRecord()
  public cookieRecords: CookieRecord[] = []
}
